import styled from 'styled-components'

interface StyledProp {
    color: string
}

export const AlarmCountCardContainer = styled.div<StyledProp>`
    width: 23%;
    height: 144px;
    display: flex;
    flex-wrap: wrap;
    border-radius: 4px 4px 0 0;
    border-top: 20px solid ${props => props.color};

    .alarm-card-content {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 20px;
        width: 100%;
        background-color: var(--gray-0);

        .count {
            color: ${props => props.color};
            font-size: 38px;
            font-weight: 600;
            margin-bottom: 15px;
        }

        .alarm-status {
            color: var(--gray-800);
            font-weight: 600;
            font-size: 9px;
        }

        .trigger {
            color: var(--gray-700);
            font-weight: 400;
        }
    }
`

export const CardColor = styled.div<StyledProp>`
    width: 100%;
    height: 20px;
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    background-color: ${props => props.color};
`

export const NoInfo = styled.div`
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    margin-bottom: 15px;
`
